import { PureComponent, Component, useState, createRef } from 'react';
import { withTranslation, useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { isBrowser, isTablet } from 'react-device-detect';
import { NotificationManager } from 'react-notifications';
import { Formik, Form } from 'formik';
import moment from 'moment';

import {
  Button,
  Dropdown,
  Grid,
  Icon,
  Modal,
  Form as SemanticForm,
  Popup,
  Radio,
  Segment,
  Search,
  Label,
} from 'semantic-ui-react';

import {
  AvForm,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from 'availity-reactstrap-validation';

import {
  CustomCheckbox,
  CustomPasswordInput,
} from '../../../../components/form';

import { CustomInput, CustomDropdown } from '../../../../components/form';

import {
  getAdminOrgUserCreateInitialValues,
  getAdminUserCreateValidationSchemaOrg,
} from '../../../../validations/AddNewIndOrOrgByAdminValidation';

import { getAdminUserCreateValidationSchemaIndv } from '../../../../validations/AddNewIndOrOrgByAdminValidation';

import {
  AvFieldUpload,
  CustomTable,
  EmptyContainer,
  CustomTooltip,
} from '../../../../components';

import {
  find,
  isEmpty,
  map,
  debounce,
  forEach,
  sortedUniq,
  uniq,
  get,
} from '../../../../utils/lodash';

import {
  isBetaLaunchAdminEmail,
  INVOICE_STATUS_OPTIONS,
} from '../../../../utils/constant';

import { INSTANCE_DEFAULT_CURRENCY_TYPE_ID } from '../../../../utils/instanceConstant';

import {
  getProvincesAndStates,
  getIndustrySectorTypes,
  getOrgAll,
  postOrganisation,
  updateOrganisationDetails,
  updateOrganizationLogo,
  getSubscriptions,
  getPaymentPreferences,
  getInvoices,
  updateMarkBy,
  getFeatures,
  getPermissionGroups,
  postAccountPermissionGroups,
  getCurrencyTypes,
} from '../../../../store/actions';

import { getInvoicesStatus, stopPropagation } from '../../../../utils';

import './userOrganization.scss';

const account_option = (t) => [
  {
    key: 'All',
    text: <b>{t('common.all')}</b>,
    value: 'all',
  },
  {
    key: 'organisation',
    text: <b>{t('account_type.organisation')}</b>,
    value: 'organisation',
  },
  {
    key: 'individual',
    text: <b>{t('account_type.individual')}</b>,
    value: 'individual',
  },
];

const status_option = (t) => [
  {
    key: 'all',
    text: <b>{t('common.all')}</b>,
    value: 'all',
  },
  {
    key: 'active',
    text: <b>{t('account_status.active')}</b>,
    value: 'active',
  },
  {
    key: 'inactive',
    text: <b>{t('account_status.inactive')}</b>,
    value: 'inactive',
  },
];

class OrganizationsBase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      currentPage: 1,
      accType: 'all',
      value: '',
      statusType: 'active',
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  async componentDidMount() {
    const {
      getIndustrySectorTypes,
      getProvincesAndStates,
      getSubscriptions,
      getPaymentPreferences,
      getCurrencyTypes,
    } = this.props;
    await Promise.all([
      getProvincesAndStates(),
      getIndustrySectorTypes(),
      getSubscriptions(),
      getPaymentPreferences(),
      getCurrencyTypes(),
    ]);
  }

  pageChange(page) {
    const { getOrgAll } = this.props;
    const { accType, statusType, value } = this.state;
    this.setState(
      {
        currentPage: page,
      },
      async () => {
        await getOrgAll(page, accType, statusType, value);
      }
    );
  }

  setFilterAccount(accType) {
    this.setState(
      {
        accType,
        currentPage: 1,
      },
      async () => {
        const { getOrgAll } = this.props;
        const { currentPage, value, statusType, accType } = this.state;
        await getOrgAll(currentPage, accType, statusType, value);
      }
    );
  }

  setFilterStatus(statusType) {
    this.setState(
      {
        statusType,
        currentPage: 1,
      },
      async () => {
        const { getOrgAll } = this.props;
        const { currentPage, accType, statusType, value } = this.state;
        await getOrgAll(currentPage, accType, statusType, value);
      }
    );
  }

  handleSearchChange = (e, { value }) => {
    this.setState({ value }, async () => {
      const { getOrgAll } = this.props;
      const { currentPage, accType, statusType } = this.state;
      await getOrgAll(currentPage, accType, statusType, value);
    });
  };

  render() {
    const { modal, accType, value, statusType } = this.state;
    const { industrySectorTypes, currencyTypes, auth, t } = this.props;

    const currencyTypeOptions = currencyTypes
      ? currencyTypes.map((item) => ({
          key: item.id,
          value: item.id,
          text: `${item.name} (${item.sign})`,
        }))
      : [];

    const loggedUserEmail = get(auth, 'user.email', null);
    const isBetaLaunchAdmin = isBetaLaunchAdminEmail(loggedUserEmail);
    return (
      <div>
        <div className="outcome-admin">
          <div className="user-search-account-settings">
            <div className="search-bar">
              <Search
                placeholder={t(
                  'admin.user_organisation.accounts.search_by_name_email'
                )}
                onSearchChange={(e, value) => this.handleSearchChange(e, value)}
                showNoResults={false}
              />
            </div>
            <div className="button-outcome">
              <Modal
                open={modal}
                onOpen={() => this.toggle()}
                closeIcon={
                  <Icon
                    onClick={() => this.toggle()}
                    name="close"
                    className="closeicon"
                  />
                }
                className="contentOrganization-edit"
                size="large"
                trigger={
                  <Button className="Primary-Button">
                    <div className="add-icon-activity-add">
                      <Icon name="plus circle" />
                      <div className="add-text">
                        {t('admin.user_organisation.accounts.add_new_account')}
                      </div>
                    </div>
                  </Button>
                }
              >
                <Modal.Header>
                  {' '}
                  <div className="add-org-header">
                    {t('admin.user_organisation.accounts.add_new_account')}
                  </div>
                </Modal.Header>

                <Modal.Content>
                  <CreateNewOrganization
                    toggle={() => this.toggle()}
                    isBetaLaunchAdmin={isBetaLaunchAdmin}
                    currencyTypeOptions={currencyTypeOptions}
                    {...this.props}
                    {...this.state}
                    industrySectorTypes={industrySectorTypes}
                  />
                </Modal.Content>
              </Modal>
            </div>
          </div>
        </div>
        <div className="outcome-admin-less-padding">
          <div className="user-search-account-filter">
            <div className="account-filter-title">
              {t('admin.user_organisation.accounts.account_type')}
            </div>
            <div className="account-filter">
              <Dropdown
                direction="right"
                inline
                selectOnBlur={false}
                options={account_option(t)}
                value={accType}
                onChange={(e, { value }) => this.setFilterAccount(value)}
              />
            </div>

            <div className="status-filter-title ">{t('common.status')}</div>
            <div className="status-filter">
              <Dropdown
                direction="right"
                inline
                selectOnBlur={false}
                options={status_option(t)}
                value={statusType}
                onChange={(e, { value }) => this.setFilterStatus(value)}
              />
            </div>
          </div>
        </div>
        <OrganizationList
          {...this.props}
          isBetaLaunchAdmin={isBetaLaunchAdmin}
          currencyTypeOptions={currencyTypeOptions}
          industrySectorTypes={industrySectorTypes}
          pageChange={(page) => this.pageChange(page)}
          currentPage={this.state.currentPage}
          accType={this.state.accType}
          statusType={this.state.statusType}
          keyword={this.state.value}
        />
      </div>
    );
  }
}

const CreateNewOrganization = ({
  toggle,
  postOrganisation,
  subscriptions,
  paymentPreferences,
  admin,
  currencyTypeOptions,
  isBetaLaunchAdmin,
  ...props
}) => {
  const [isOrganisation, setIsOrganisation] = useState(true);
  const [isDemo, setIsDemo] = useState(false);
  const [isBetaTester, setIsBetaTester] = useState(false);
  const [isEnvironmentalTester, setIsEnvironmentalTester] = useState(false);
  const [gradedQuestions, setGradedQuestions] = useState(false);
  const [
    activityUsesQuestionBetaByDefault,
    setActivityUsesQuestionBetaByDefault,
  ] = useState(false);
  const [isEvidenceBlock, setIsEvidenceBlock] = useState(false);
  const [isTaksoAdminEmail, setIsTaksoAdminEmail] = useState(false);
  const { t } = useTranslation();

  const handleInputChange = (name) => {
    switch (name) {
      case 'isOrganisation':
        setIsOrganisation(!isOrganisation);
        break;
      case 'isDemo':
        setIsDemo(!isDemo);
        break;
      case 'isBetaTester':
        setIsBetaTester(!isBetaTester);
        break;
      case 'isEnvironmentalTester':
        setIsEnvironmentalTester(!isEnvironmentalTester);
        break;
      case 'gradedQuestions':
        setGradedQuestions(!gradedQuestions);
        break;
      case 'activityUsesQuestionBetaByDefault':
        setActivityUsesQuestionBetaByDefault(
          !activityUsesQuestionBetaByDefault
        );
        break;
      case 'isEvidenceBlock':
        setIsEvidenceBlock(!isEvidenceBlock);
        break;
      default:
        break;
    }
  };

  const handleValidSubmit = async (values) => {
    try {
      const orgData = isOrganisation
        ? {
            organisation: {
              domain: values.orgDomain,
              industrySectorTypeId: values.orgIndustrySectorTypeId,
              email: values.orgEmail,
              phone: values.orgPhone,
              name: values.organisationName,
              isDemo,
              isBetaTester,
              isEnvironmentalTester,
              gradedQuestions,
              activityUsesQuestionBetaByDefault,
              isEvidenceBlock,
              currencyTypeId: isBetaLaunchAdmin
                ? values.currencyTypeId
                : INSTANCE_DEFAULT_CURRENCY_TYPE_ID,
            },
            user: {
              email: values.userEmail,
              isTaksoAdminEmail,
              firstName: values.userFirstName,
              surname: values.userSurname,
              password: values.password,
            },
          }
        : {
            individual: {
              email: values.userEmailIndv,
              isTaksoAdminEmail,
              password: values.passwordIndv,
              paymentPreferenceId: values.individualPaymentPreferenceId,
              firstName: values.userFirstNameIndv,
              surname: values.userSurnameIndv,
              phone: values.userPhoneIndv,
              subscription: values.individualSubscription,
              isDemo,
              isBetaTester,
              isEnvironmentalTester,
              gradedQuestions,
              activityUsesQuestionBetaByDefault,
              isEvidenceBlock: isEvidenceBlock,
              currencyTypeId: isBetaLaunchAdmin
                ? values.currencyTypeId
                : INSTANCE_DEFAULT_CURRENCY_TYPE_ID,
            },
          };

      await postOrganisation(orgData);
      toggle();
    } catch (error) {
      console.error('CreateNewOrganization ~ handleValidSubmit ~ error', error);
    }
  };

  const selectType = (value) => {
    setIsOrganisation(value === 'organisation');
  };

  const renderSubscriptions = () => {
    return subscriptions
      .filter((item) => item.accountTypes.includes('INDIVIDUAL'))
      .map((item, key) => {
        return {
          key,
          text: item.title,
          value: item.id.toString(),
        };
      });
  };
  const renderPaymentPreference = () => {
    return paymentPreferences.map((item, key) => {
      return {
        key,
        text: item.title,
        value: item.id,
      };
    });
  };
  return (
    <div>
      <div className="admin-org-user-upper">
        <div className="org-inputs">
          {t('admin.user_organisation.accounts.account_type_and_subscription')}
        </div>
        <div className="radio-org-add">
          <label className="admin-org-acc-type">
            {t('admin.user_organisation.accounts.select_account_type')}
          </label>
          <SemanticForm className="org-radio">
            <Grid>
              <Grid.Row>
                <SemanticForm.Field>
                  <Radio
                    label={t('account_type.individual')}
                    name="group"
                    className="org-inputs"
                    value="individual"
                    onChange={(e, { value }) => selectType(value)}
                    checked={!isOrganisation}
                  />
                </SemanticForm.Field>
              </Grid.Row>
              <Grid.Row>
                <SemanticForm.Field>
                  <Radio
                    label={t('account_type.organisation')}
                    name="group"
                    className="org-inputs"
                    value="organisation"
                    onChange={(e, { value }) => selectType(value)}
                    checked={isOrganisation}
                  />
                </SemanticForm.Field>
              </Grid.Row>
            </Grid>
          </SemanticForm>
        </div>
      </div>
      <Formik
        initialValues={getAdminOrgUserCreateInitialValues(admin)}
        onSubmit={(values) => {
          handleValidSubmit(values);
        }}
        validationSchema={
          isOrganisation
            ? getAdminUserCreateValidationSchemaOrg(
                t,
                isTaksoAdminEmail,
                isBetaLaunchAdmin
              )
            : getAdminUserCreateValidationSchemaIndv(
                t,
                isTaksoAdminEmail,
                isBetaLaunchAdmin
              )
        }
      >
        {({ handleSubmit }) => {
          return (
            <Form onSubmit={handleSubmit}>
              {isOrganisation ? (
                <Grid columns={2} divided stackable>
                  <Grid.Row className=" ">
                    <Grid.Column mobile={16} tablet={8} computer={8}>
                      <>
                        <div className="org-details-header">
                          {t(
                            'admin.user_organisation.accounts.organisation_details'
                          )}
                        </div>
                        <OrganizationDetail
                          currencyTypeOptions={currencyTypeOptions}
                          isBetaLaunchAdmin={isBetaLaunchAdmin}
                          onChange={handleInputChange}
                          isDemo={isDemo}
                          isBetaTester={isBetaTester}
                          isEnvironmentalTester={isEnvironmentalTester}
                          isEvidenceBlock={isEvidenceBlock}
                          gradedQuestions={gradedQuestions}
                          activityUsesQuestionBetaByDefault={
                            activityUsesQuestionBetaByDefault
                          }
                          {...props}
                        />
                      </>
                    </Grid.Column>
                    <Grid.Column
                      mobile={16}
                      tablet={8}
                      computer={8}
                      className="org-modal-column "
                    >
                      <OrganizationForAdmin
                        isTaksoAdminEmail={isTaksoAdminEmail}
                        setIsTaksoAdminEmail={() => {
                          setIsTaksoAdminEmail(!isTaksoAdminEmail);
                        }}
                        {...props}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              ) : (
                <Grid columns={2}>
                  <Grid.Row>
                    <Grid.Column className="">
                      <CustomDropdown
                        name="individualSubscription"
                        id="individualSubscription"
                        labelText={t(
                          'admin.user_organisation.accounts.subscription'
                        )}
                        options={renderSubscriptions()}
                        placeholder={t(
                          'admin.user_organisation.accounts.select_subscription'
                        )}
                        selection
                        requiredStar
                        className="org-inputs"
                      />
                    </Grid.Column>
                    <Grid.Column className="org-ind-subscripton">
                      <CustomDropdown
                        name="individualPaymentPreferenceId"
                        id="individualPaymentPreferenceId"
                        labelText={t(
                          'admin.user_organisation.accounts.payment_preference'
                        )}
                        options={renderPaymentPreference()}
                        placeholder={t(
                          'admin.user_organisation.accounts.select_payment_preference'
                        )}
                        selection
                        requiredStar
                        className="org-inputs"
                      />
                    </Grid.Column>

                    {isBetaLaunchAdmin && (
                      <Grid.Column>
                        <CustomDropdown
                          name="currencyTypeId"
                          id="currencyTypeId"
                          className="org-inputs"
                          labelText={t('formulary.currency_type')}
                          options={currencyTypeOptions}
                          placeholder={t(
                            'formulary.placeholder.select_currency_type'
                          )}
                          selection
                          requiredStar
                          search
                        />
                      </Grid.Column>
                    )}
                  </Grid.Row>
                  <Grid.Row className="org-details-raw">
                    <Grid.Column mobile={16} tablet={8} computer={8}>
                      <div>
                        <div className="org-details-header">
                          {t('admin.user_organisation.accounts.admin_details')}
                        </div>
                        <IndividualDetails
                          isTaksoAdminEmail={isTaksoAdminEmail}
                          onChange={handleInputChange}
                          isDemo={isDemo}
                          isBetaTester={isBetaTester}
                          isEnvironmentalTester={isEnvironmentalTester}
                          isEvidenceBlock={isEvidenceBlock}
                          {...props}
                        />
                      </div>
                    </Grid.Column>
                    <Grid.Column
                      mobile={16}
                      tablet={8}
                      computer={8}
                      className="org-modal-column "
                    >
                      <IndividualRightSide
                        isTaksoAdminEmail={isTaksoAdminEmail}
                        setIsTaksoAdminEmail={() => {
                          setIsTaksoAdminEmail(!isTaksoAdminEmail);
                        }}
                        {...props}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              )}

              <div className="model-buttons-org">
                <Button
                  className="Secondary-Button"
                  type="button"
                  onClick={() => toggle()}
                >
                  {t('actions.cancel')}
                </Button>
                <Button
                  content={t('actions.create')}
                  type="submit"
                  className="Primary-Button"
                  loading={admin.postOrgLoading}
                  disabled={admin.postOrgLoading}
                />
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

const OrganizationDetail = ({
  isBetaLaunchAdmin,
  currencyTypeOptions,
  industrySectorTypes,
  onChange,
  isDemo,
  isBetaTester,
  isEnvironmentalTester,
  isEvidenceBlock,
  gradedQuestions,
  activityUsesQuestionBetaByDefault,
}) => {
  const { t } = useTranslation();
  const selectSectorType = () => {
    return industrySectorTypes.map((item, key) => {
      return {
        key,
        text: item.name,
        value: item.id,
      };
    });
  };

  return (
    <div className="down-modal">
      <CustomInput
        id="organisationName"
        name="organisationName"
        className="org-inputs"
        labelText={t('formulary.organisation_name')}
        requiredStar
      />
      <CustomDropdown
        name="orgIndustrySectorTypeId"
        id="orgIndustrySectorTypeId"
        className="org-inputs"
        labelText={t('formulary.organisation_sector_type')}
        options={selectSectorType()}
        placeholder={t('formulary.placeholder.select_sector')}
        selection
        requiredStar
        search
      />{' '}
      {isBetaLaunchAdmin && (
        <CustomDropdown
          name="currencyTypeId"
          id="currencyTypeId"
          className="org-inputs"
          labelText={t('formulary.currency_type')}
          options={currencyTypeOptions}
          placeholder={t('formulary.placeholder.select_currency_type')}
          selection
          requiredStar
          search
        />
      )}
      <CustomInput
        id="orgPhone"
        name="orgPhone"
        placeholder={t('formulary.placeholder.enter_phone')}
        className="org-inputs"
        labelText={t('formulary.phone')}
        requiredStar
      />
      <CustomInput
        id="orgDomain"
        name="orgDomain"
        placeholder={t('formulary.placeholder.enter_web_domain')}
        className="org-inputs"
        labelText={t('formulary.web_domain')}
        requiredStar
      />
      <CustomInput
        id="orgEmail"
        name="orgEmail"
        placeholder={t('formulary.placeholder.enter_email')}
        labelText={t('formulary.email')}
        className="org-inputs"
        requiredStar
      />
      <div className="account-type-toggle">
        <div className="edit-outcome-status-bar">
          <div className="two-step-radio-container-admin radio-right">
            <Radio
              toggle
              className="modal-toggle-qs-acctype"
              checked={isEvidenceBlock}
              onChange={() => onChange('isEvidenceBlock')}
            />
          </div>
          <label>{t('admin.user_organisation.accounts.block_evidence')}</label>
        </div>
        <div className="edit-outcome-status-bar">
          <div className="two-step-radio-container-admin radio-right">
            <Radio
              toggle
              className="modal-toggle-qs-acctype"
              checked={isDemo}
              onChange={() => onChange('isDemo')}
            />
          </div>
          <label>{t('admin.user_organisation.accounts.demo_account')}</label>
        </div>
      </div>
      <div className="account-type-toggle">
        <div className="edit-outcome-status-bar">
          <div className="two-step-radio-container-admin radio-right">
            <Radio
              toggle
              className="modal-toggle"
              checked={isBetaTester}
              onChange={() => onChange('isBetaTester')}
            />
          </div>
          <label>{t('common.beta_tester')}</label>
        </div>
      </div>
      <div className="account-type-toggle">
        <div className="edit-outcome-status-bar">
          <div className="two-step-radio-container-admin radio-right">
            <Radio
              toggle
              className="modal-toggle"
              checked={isEnvironmentalTester}
              onChange={() => onChange('isEnvironmentalTester')}
            />
          </div>
          <label>{t('organisation.permissions.environmental_tester')}</label>
        </div>
      </div>
      <div className="account-type-toggle">
        <div className="edit-outcome-status-bar">
          <div className="two-step-radio-container-admin radio-right">
            <Radio
              toggle
              className="modal-toggle"
              checked={gradedQuestions}
              onChange={() => onChange('gradedQuestions')}
            />
          </div>
          <label>{t('admin.user_organisation.graded_questions')}</label>
        </div>
      </div>
      <div className="account-type-toggle">
        <div className="edit-outcome-status-bar">
          <div className="two-step-radio-container-admin radio-right">
            <Radio
              toggle
              className="modal-toggle"
              checked={activityUsesQuestionBetaByDefault}
              onChange={() => onChange('activityUsesQuestionBetaByDefault')}
            />
          </div>
          <label>{t('admin.user_organisation.accounts.graded_qsts')}</label>
        </div>
      </div>
    </div>
  );
};

const OrganizationForAdmin = ({
  isTaksoAdminEmail,
  setIsTaksoAdminEmail,
  ...props
}) => {
  const [isShownPass, setIsShownPass] = useState(false);
  const { t } = useTranslation();

  return (
    <div>
      <div className="add-org-admin ">
        <div className="org-header">{t('role.organisation_admin')}</div>
      </div>

      <div className="down-modal-admin">
        <CustomInput
          id="userFirstName"
          name="userFirstName"
          placeholder={t('formulary.placeholder.enter_first_name')}
          className="org-inputs"
          labelText={t('formulary.first_name')}
          requiredStar
        />
        <CustomInput
          id="userSurname"
          name="userSurname"
          placeholder={t('formulary.placeholder.enter_surname')}
          className="org-inputs"
          labelText={t('formulary.surname')}
          requiredStar
        />

        <CustomInput
          id="userEmail"
          name="userEmail"
          placeholder={t('formulary.placeholder.enter_email')}
          className="org-inputs"
          labelText={t('formulary.email')}
          requiredStar
        />

        <CustomCheckbox
          className="check-box"
          id="isTaksoAdminEmail"
          name="isTaksoAdminEmail"
          label={t('formulary.takso_support_email')}
          checked={isTaksoAdminEmail}
          onChange={() => setIsTaksoAdminEmail()}
        />

        {isTaksoAdminEmail && (
          <>
            <CustomPasswordInput
              id="password"
              name="password"
              className="org-inputs"
              labelText={t('formulary.new_password')}
              placeholder={t('formulary.placeholder.enter_new_password')}
            />

            <CustomInput
              id="confirmPassword"
              className="org-inputs"
              name="confirmPassword"
              placeholder={t('formulary.placeholder.enter_confirm_password')}
              labelText={t('formulary.confirm_password')}
              type={isShownPass ? 'text' : 'password'}
              icon={
                <Icon
                  name={isShownPass ? 'eye' : 'eye slash'}
                  onClick={() => {
                    setIsShownPass(!isShownPass);
                  }}
                  link
                />
              }
            />
          </>
        )}
      </div>
    </div>
  );
};

class OrganizationList extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      checked: false,
    };
  }

  getTableColumns() {
    const { t, i18n } = this.props;
    return [
      {
        width: 6,
        title: (
          <div>
            <strong>{t('common.account')}</strong>
          </div>
        ),
        render: (data) => {
          const hasBadges =
            !data.isActive ||
            data.isDemo ||
            data.isBetaTester ||
            data.isEvidenceBlock;

          return (
            <div className="blocked-badge-container">
              <div className={`org-name ${!data.isActive ? 'disabled' : ''}`}>
                {data.name}
                <span className="org-id">
                  {t('formulary.id')} #{data.id}
                </span>
              </div>
              {hasBadges && (
                <div className="blocked-badges">
                  {!data.isActive && (
                    <Label className="blocked-badge" color="red" size="tiny">
                      {t('common.disabled')}
                    </Label>
                  )}
                  {data.isDemo && (
                    <Label className="demo-badge" color="purple" size="tiny">
                      {t('admin.user_organisation.accounts.badges.demo')}
                    </Label>
                  )}
                  {data.isBetaTester && (
                    <Label
                      className="beta-tester-badge"
                      color="green"
                      size="tiny"
                    >
                      {t('common.beta_tester')}
                    </Label>
                  )}
                  {data.isEvidenceBlock && (
                    <Label
                      className="evidence-block-badge"
                      color="black"
                      size="tiny"
                    >
                      {t(
                        'admin.user_organisation.accounts.badges.evidence_blocked'
                      )}
                    </Label>
                  )}
                </div>
              )}
            </div>
          );
        },
        textAlign: isBrowser || isTablet ? 'left' : null,
      },
      {
        width: 2,
        title: (
          <div className="user-heading-container">
            <strong>{t('common.type')}</strong>
          </div>
        ),
        render: (data) => {
          return (
            <div className={!data.isActive ? 'disabled' : ''}>
              {data.type === 'ORGANISATION'
                ? t('common.organisation')
                : t('admin.individual.label')}
            </div>
          );
        },
        textAlign: isBrowser || isTablet ? 'centre' : null,
      },
      {
        width: 2,
        title: (
          <div className="user-heading-container">
            <strong>
              {t('admin.user_organisation.accounts.organisation_code')}
            </strong>
          </div>
        ),
        render: (data) => {
          return (
            <div className={!data.isActive ? 'disabled' : ''}>
              {get(data, 'organisationCode', '-')}
            </div>
          );
        },
        textAlign: isBrowser || isTablet ? 'centre' : null,
      },
      {
        width: 2,
        title: (
          <div className="user-heading-container">
            <strong>{t('admin.user_organisation.accounts.no_of_users')}</strong>
          </div>
        ),
        render: (data) => {
          return (
            <div className={!data.isActive ? 'disabled' : ''}>
              {data.noOfUsers}
            </div>
          );
        },
        textAlign: isBrowser || isTablet ? 'centre' : null,
      },
      {
        width: 2,
        title: (
          <div className="user-heading-container">
            <strong>
              {t('admin.user_organisation.accounts.last_payment')}
            </strong>
          </div>
        ),
        render: (data) => {
          return (
            <div className={!data.isActive ? 'disabled' : ''}>
              {!isEmpty(data.invoices) && data.invoices.createdAt
                ? new Intl.DateTimeFormat(i18n.language, {
                    weekday: 'short',
                    day: '2-digit',
                    month: 'short',
                    year: 'numeric',
                  }).format(new Date(data.invoices.createdAt))
                : '-'}
            </div>
          );
        },
        textAlign: isBrowser || isTablet ? 'left' : null,
      },
      {
        width: 3,
        title: (
          <div className="user-heading-container">
            <strong>{t('common.created_date')}</strong>
          </div>
        ),
        render: (data) => {
          return (
            <div className={!data.isActive ? 'disabled' : ''}>
              {!isEmpty(data.createdDateTime)
                ? new Intl.DateTimeFormat(i18n.language, {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                  }).format(new Date(data.createdDateTime))
                : '-'}
            </div>
          );
        },
        textAlign: isBrowser || isTablet ? 'left' : null,
      },
      {
        width: 1,
        title: (
          <div className="user-act-heading-container">
            <strong></strong>
          </div>
        ),
        render: (data) => {
          return (
            <div className="owned">
              <Dropdown
                icon="ellipsis vertical"
                direction="left"
                inline
                selectOnBlur={false}
              >
                <Dropdown.Menu>
                  <EditOrganization data={data} {...this.props} />

                  {data.type === 'INDIVIDUAL' ? (
                    <Dropdown.Item
                      text={t(
                        'admin.user_organisation.accounts.billing_and_invoices'
                      )}
                      className="dropdown-customItem"
                    >
                      <BillingInvoices data={data} {...this.props} />
                    </Dropdown.Item>
                  ) : null}
                  <PermissionGroup data={data} {...this.props} />
                </Dropdown.Menu>
              </Dropdown>
            </div>
          );
        },
        textAlign: isBrowser || isTablet ? 'center' : null,
      },
    ];
  }

  async componentDidMount() {
    try {
      const { currentPage } = this.props;
      const { getOrgAll } = this.props;
      await getOrgAll(currentPage);
    } catch (error) {}
  }

  render() {
    const { currentPage, pageChange, t } = this.props;

    const { allOrganisations, allOrgLoading } = this.props.admin;

    return (
      <Segment
        className="content-segment p-0"
        loading={allOrgLoading}
        disabled={allOrgLoading}
      >
        {allOrganisations.docs && allOrganisations.docs.length ? (
          <CustomTable
            header
            columns={this.getTableColumns()}
            data={allOrganisations.docs}
            pagination
            handlePaginationChange={(page) => pageChange(page)}
            customClass="super-admin-table tbody-hover"
            page={currentPage}
            noOfPages={allOrganisations.pages}
            keyExtractor={(item, index) => item.id}
          />
        ) : (
          <EmptyContainer msg={t('empty_message.no_organisations')} />
        )}
      </Segment>
    );
  }
}

class PermissionGroup extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      selectedFeatuers: [],
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  setSelectedFeatuers = (featuerList) => {
    this.setState({
      selectedFeatuers: featuerList,
    });
  };

  render() {
    const { modal, selectedFeatuers } = this.state;
    const { t } = this.props;
    return (
      <div className="button-outcome">
        <Modal
          open={modal}
          onOpen={() => this.toggle()}
          onClick={(e) => stopPropagation(e)}
          onFocus={(e) => stopPropagation(e)}
          closeIcon={
            <Icon
              onClick={() => this.toggle()}
              name="close"
              className="closeicon"
            />
          }
          className="account-permission-group"
          size="large"
          trigger={
            <Dropdown.Item>
              <label className="edit-org">
                {t('admin.user_organisation.accounts.edit_permission')}
                <Icon name="unlock" />
              </label>
            </Dropdown.Item>
          }
        >
          <Modal.Header>
            <div className="add-org-header">
              {t('admin.user_organisation.accounts.account_permission_group')}
            </div>
          </Modal.Header>

          <Modal.Content>
            <PermissionGroupForm
              selectedFeatuers={selectedFeatuers}
              setSelectedFeatuers={this.setSelectedFeatuers}
              toggle={() => this.toggle()}
              {...this.props}
            />
          </Modal.Content>
        </Modal>
      </div>
    );
  }
}

class PermissionGroupForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isActive: true,
      permissionGroupValue: [],
      redundantPermission: [],
      isPermissionEmpty: false,
    };
  }

  async componentDidMount() {
    const { getFeatures, getPermissionGroups, data, setSelectedFeatuers } =
      this.props;
    getFeatures(0);
    getPermissionGroups(0);
    const permissionGroups = [];
    const permissionFeatures = [];
    forEach(data.organisationFeatures, (group) => {
      permissionGroups.push(group.featureGroup.groupId);
      permissionFeatures.push(group.featureGroup.featureId);
    });
    this.setState({
      permissionGroupValue: sortedUniq(permissionGroups),
    });
    setSelectedFeatuers(permissionFeatures);
  }

  async handleValidSubmit(event, values) {
    try {
      const {
        postAccountPermissionGroups,
        pageChange,
        currentPage,
        toggle,
        data,
        selectedFeatuers,
        setSelectedFeatuers,
      } = this.props;
      if (!this.state.permissionGroupValue.length) {
        this.setState({ isPermissionEmpty: true });
        setSelectedFeatuers([]);
        return;
      }

      const isMultiLevelProgramSelected = selectedFeatuers.some(
        (item) => item === 38
      );

      if (isMultiLevelProgramSelected) {
        const isProgramSelected = isMultiLevelProgramSelected
          ? selectedFeatuers.some((item) => [35, 36, 37].includes(item))
          : false;

        if (!isProgramSelected) return;
      }

      values.organisationId = data.id;
      values.permissionGroup = this.state.permissionGroupValue;
      values.features = selectedFeatuers;

      await postAccountPermissionGroups(values);
      pageChange(currentPage);
      toggle();
    } catch (error) {
      console.error('Permission create submit ~~', error);
    }
  }

  getOptions() {
    const { getPermissionGroup, selectedFeatuers, t } = this.props;
    const { docs } = getPermissionGroup;
    return map(docs, (permission) => {
      // TODO:i18n - omg - what if we are in a different language? yuck!!
      const isMultiLevelProgram = permission.name === 'Multi Level Program';

      // TODO - wtf is it with hardcoding IDs????
      const isProgramSelected = isMultiLevelProgram
        ? selectedFeatuers.some((item) => [35, 36, 37].includes(item))
        : false;

      return {
        disabled: isMultiLevelProgram && !isProgramSelected,
        key: permission.id,
        text: (
          <>
            {isMultiLevelProgram && !isProgramSelected ? (
              <Popup
                content={
                  <div>
                    {t(
                      'admin.user_organisation.accounts.required_program_feature'
                    )}
                  </div>
                }
                position="top left"
                trigger={<p>{permission.name}</p>}
              />
            ) : (
              permission.name
            )}
          </>
        ),
        value: permission.id,
        permission: permission,
      };
    });
  }

  featureIsChecked(id) {
    const { selectedFeatuers } = this.props;

    const isExist = find(selectedFeatuers, (feature) => feature === id);
    return isExist ? true : false;
  }

  permissionGroupOnChange(value) {
    this.setState({ permissionGroupValue: uniq(value) });

    const { getPermissionGroup, setSelectedFeatuers } = this.props;
    if (isEmpty(value)) {
      setSelectedFeatuers([]);
    }

    const { docs } = getPermissionGroup;
    let featuerList = [];
    let redundantPermissionGroups = [];
    forEach(value, (PermissionGroupId) => {
      const PermissionGroup = find(docs, (doc) => doc.id === PermissionGroupId);
      let isRedundant = true;
      forEach(PermissionGroup.featureGroup, (feature) => {
        const isExist = find(
          featuerList,
          (featureId) => feature.featureId === featureId
        );
        if (!isExist) {
          featuerList.push(feature.featureId);
          isRedundant = false;
        }
      });
      if (isRedundant) redundantPermissionGroups.push(PermissionGroup.name);
      setSelectedFeatuers(featuerList);
    });

    if (redundantPermissionGroups.length)
      this.setState({
        redundantPermission: redundantPermissionGroups,
        isPermissionEmpty: false,
      });
    else this.setState({ redundantPermission: [], isPermissionEmpty: false });
  }

  render() {
    const { toggle, features, getfeatureLoading, t } = this.props;
    const { permissionGroupValue, redundantPermission, isPermissionEmpty } =
      this.state;

    return (
      <AvForm
        ref={(c) => (this.form = c)}
        onValidSubmit={(event, values) => this.handleValidSubmit(event, values)}
        className="venue-form"
      >
        <label>{t('admin.user_organisation.accounts.permission_group')}</label>
        {redundantPermission.length ? (
          <div className="invalid-permission-group-custom">
            {t(
              'admin.user_organisation.accounts.will_be_not_added_since_all_feature_groups_are_redundant',
              {
                redundantPermission: redundantPermission.join('","'),
              }
            )}
          </div>
        ) : null}
        <Dropdown
          placeholder={t('admin.user_organisation.accounts.permissions')}
          fluid
          className="org-inputs"
          multiple
          selection
          options={this.getOptions()}
          value={uniq(permissionGroupValue)}
          onChange={(event, { value }) => this.permissionGroupOnChange(value)}
        />
        {isPermissionEmpty ? (
          <div className="invalid-permission-group-custom">
            {t(
              'admin.user_organisation.accounts.select_at_least_one_permission_group'
            )}
          </div>
        ) : null}

        <label className="mt-4">
          {t('admin.user_organisation.accounts.features')}
        </label>
        <Segment
          className="content-segment mt-0"
          loading={getfeatureLoading}
          disabled={getfeatureLoading}
        >
          {features.docs && features.docs.length ? (
            <AvCheckboxGroup inline name="features">
              <Grid>
                {map(features.docs, (doc, i) => (
                  <Grid.Column
                    key={doc.id}
                    className="permission-features-list"
                    computer={5}
                    verticalAlign="middle"
                  >
                    <CustomTooltip
                      state={true}
                      content={doc.description}
                      position="top left"
                      wide="very"
                    >
                      <div>{doc.displayName}</div>
                    </CustomTooltip>
                    {/* <AvCheckbox
                      onChange={(e) => {}}
                      value={doc.id}
                      checked={this.featureIsChecked(doc.id)}
                    /> */}

                    {this.featureIsChecked(doc.id) ? (
                      <Icon
                        name="check circle"
                        className="permission-check"
                        size="large"
                      />
                    ) : (
                      <Icon
                        name="times circle"
                        className="permission-close"
                        size="large"
                      />
                    )}
                  </Grid.Column>
                ))}
              </Grid>
            </AvCheckboxGroup>
          ) : (
            <EmptyContainer
              msg={t('admin.user_organisation.accounts.no_features')}
            />
          )}
        </Segment>

        <div className="model-buttons">
          <Button
            className="Secondary-Button"
            type="button"
            onClick={() => toggle()}
          >
            {t('actions.cancel')}
          </Button>
          <Button
            content={t('admin.user_organisation.accounts.update_permission')}
            type="submit"
            className="Primary-Button"
            // loading={postPermissionGroupLoading}
            // disabled={postPermissionGroupLoading}
          />
        </div>
      </AvForm>
    );
  }
}

class EditOrganization extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      form: {
        orgName: '',
        orgSector: '',
        phone: '',
        webDomain: '',
        email: '',
        streetAddress: '',
        city: '',
        postCode: '',
        currencyTypeId: '',
      },
    };
  }

  editOrganization(form) {
    form.stateId = Boolean(form.stateId) ? form.stateId : '';
    form.postalStateId = form.postalStateId === null ? '' : form.postalStateId;
    this.setState({
      form,
    });
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  render() {
    const { modal, form } = this.state;
    const { data, currencyTypeOptions, isBetaLaunchAdmin, t } = this.props;
    return (
      <div className="button-outcome">
        <Modal
          open={modal}
          onOpen={() => this.toggle()}
          onClick={(e) => stopPropagation(e)}
          onFocus={(e) => stopPropagation(e)}
          closeIcon={
            <Icon
              onClick={() => this.toggle()}
              name="close"
              className="closeicon"
            />
          }
          className="contentOrganization-edit"
          size="large"
          trigger={
            <Dropdown.Item
              text={t('admin.user_organisation.users.edit_organisation')}
              className="dropdown-customItem"
            >
              <label
                className="edit-org"
                onClick={() => this.editOrganization(data)}
              >
                {t('admin.user_organisation.accounts.edit_account')}
                <Icon name="write" />
              </label>
            </Dropdown.Item>
          }
        >
          <Modal.Header>
            <div className="add-org-header">
              {t('admin.user_organisation.accounts.edit_account_type')} -{' '}
              {form.type}
            </div>
          </Modal.Header>

          <Modal.Content>
            <EditOrganizationModal
              form={form}
              isBetaLaunchAdmin={isBetaLaunchAdmin}
              currencyTypeOptions={currencyTypeOptions}
              toggle={() => this.toggle()}
              {...this.props}
            />
          </Modal.Content>
        </Modal>
      </div>
    );
  }
}

class EditOrganizationModal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      collapse: true,
      advanceCollapse: false,
      submitLoading: false,
      isChecked: false,
      isEvidenceBlock: false,
      isDemo: false,
      isBetaTester: false,
      isEnvironmentalTester: false,
      gradedQuestions: false,
      activityUsesQuestionBetaByDefault: false,
      isActive: false,
    };
    this.fileInput = createRef();
    this.diffAddress = this.diffAddress.bind(this);
  }

  diffAddress() {
    this.setState((prevState) => ({
      isChecked: !prevState.isChecked,
    }));
  }

  renderState() {
    const { provincesAndStates } = this.props;
    return map(provincesAndStates, (item, i) => (
      <option key={i} value={item.id}>
        {item.name}
      </option>
    ));
  }

  selectSectorType() {
    const { industrySectorTypes } = this.props;

    return map(industrySectorTypes, (item, i) => {
      return (
        <option key={i} value={item.id}>
          {item.name}
        </option>
      );
    });
  }

  currencyTypeOptions() {
    const { currencyTypeOptions } = this.props;

    return map(currencyTypeOptions, (item) => {
      const { key, value, text } = item;
      return (
        <option key={key} value={value}>
          {text}
        </option>
      );
    });
  }

  onChange = (value) => {
    switch (value) {
      case 'isDisable':
        this.setState({
          isActive: !this.state.isActive,
        });
        break;
      case 'isDemo':
        this.setState({
          isDemo: !this.state.isDemo,
        });
        break;
      case 'isBetaTester':
        this.setState({
          isBetaTester: !this.state.isBetaTester,
        });
        break;
      case 'isEnvironmentalTester':
        this.setState({
          isEnvironmentalTester: !this.state.isEnvironmentalTester,
        });
        break;
      case 'gradedQuestions':
        this.setState({
          gradedQuestions: !this.state.gradedQuestions,
        });
        break;
      case 'activityUsesQuestionBetaByDefault':
        this.setState({
          activityUsesQuestionBetaByDefault:
            !this.state.activityUsesQuestionBetaByDefault,
        });
        break;
      case 'isEvidenceBlock':
        this.setState({
          isEvidenceBlock: !this.state.isEvidenceBlock,
        });
        break;

      default:
        break;
    }
  };

  async componentDidMount() {
    const { form } = this.props;

    this.setState({
      isActive: form.isActive,
      isDemo: form.isDemo,
      isBetaTester: form.isBetaTester,
      isEnvironmentalTester: form.isEnvironmentalTester,
      gradedQuestions: form.gradedQuestions,
      isEvidenceBlock: form.isEvidenceBlock,
      activityUsesQuestionBetaByDefault: form.activityUsesQuestionBetaByDefault,
      isChecked:
        form.postalStreetAddress ||
        form.postalStreetAddress2 ||
        form.postalCitySuburb ||
        form.postalStateId ||
        form.postalPostcode,
    });

    /*******
    if (form.isActive === true) {
      this.setState({ isActive: true });
    }
    if (form.isDemo === true) {
      this.setState({ isDemo: true });
    }
    if (form.isBetaTester === true) {
      this.setState({ isBetaTester: true });
    }
    if (form.isEvidenceBlock === true) {
      this.setState({ isEvidenceBlock: true });
    }

    this.setState({ isEvidenceBlock: Boolean(form.isEvidenceBlock) });
    if (
      form.postalStreetAddress ||
      form.postalStreetAddress2 ||
      form.postalCitySuburb ||
      form.postalStateId ||
      form.postalPostcode
    ) {
      this.setState({ isChecked: true });
    }
    ********/
  }

  handleValidSubmit(event, values) {
    const { t } = this.props;

    delete values.isAccountType;
    this.setState(
      {
        submitLoading: true,
      },
      async () => {
        try {
          const { form, toggle, accType, currentPage } = this.props;

          const {
            isEvidenceBlock,
            isActive,
            isDemo,
            isBetaTester,
            isEnvironmentalTester,
            gradedQuestions,
            activityUsesQuestionBetaByDefault,
          } = this.state;

          const file = this.fileInput.current
            ? this.fileInput.current.getCurrentImage()
            : null;
          delete values.diffPostalAddress;
          if (!this.state.isChecked) {
            values.postalStreetAddress = null;
            values.postalStreetAddress2 = null;
            values.postalCitySuburb = null;
            values.postalStateId = null;
            values.postalPostcode = null;
          }

          if (file) {
            await this.props.updateOrganizationLogo(file, form.id);
          }

          let data = {};

          if (form.type === 'INDIVIDUAL') {
            data = {
              individual: {
                ...values.individual,
                phone: values.phone,
                email: values.email,
                paymentPreferenceId: values.paymentPreferenceId,
                isDemo,
                isBetaTester,
                isEnvironmentalTester,
                gradedQuestions,
                activityUsesQuestionBetaByDefault,
                isActive,
                isEvidenceBlock,
                currencyTypeId: get(
                  values,
                  'currencyTypeId',
                  INSTANCE_DEFAULT_CURRENCY_TYPE_ID
                ), //
              },
            };
          } else {
            data = {
              ...values,
              isDemo,
              isBetaTester,
              isEnvironmentalTester,
              gradedQuestions,
              activityUsesQuestionBetaByDefault,
              isActive,
              isEvidenceBlock,
              currencyTypeId: get(
                values,
                'currencyTypeId',
                INSTANCE_DEFAULT_CURRENCY_TYPE_ID
              ),
            };
          }

          await this.props.updateOrganisationDetails(
            form.id,
            data,
            currentPage,
            accType
          );
          await this.setState({ submitLoading: false });
          toggle();

          this.form && this.form.reset();
        } catch (error) {
          console.error('error from updating organization: ', error);
          this.setState({
            submitLoading: false,
          });
          NotificationManager.error(t('utils.error.something_wrong'));
        }
      }
    );
  }

  renderSubscriptionsEdit() {
    const { subscriptions, form } = this.props;
    const subscription = find(subscriptions, {
      id: parseInt(form.subscriptionId),
    });

    if (!subscription) return null;
    return <div className="subscription-title">{subscription.title}</div>;
  }

  renderPaymentPreferenceEdit() {
    const { paymentPreferences } = this.props;
    return map(paymentPreferences, (item, i) => {
      return (
        <option key={i} value={item.id}>
          {item.title}
        </option>
      );
    });
  }

  render() {
    const { toggle, form, isBetaLaunchAdmin, t } = this.props;
    const file = form.logo ? form.logo.documentUrl : null;
    const defaultValueLogo = file ? file : null;
    const {
      isEvidenceBlock,
      isChecked,
      submitLoading,
      isActive,
      isDemo,
      isBetaTester,
      isEnvironmentalTester,
      gradedQuestions,
      activityUsesQuestionBetaByDefault,
    } = this.state;

    return (
      <AvForm
        onValidSubmit={(event, values) => this.handleValidSubmit(event, values)}
        model={form}
      >
        <Grid columns={2} divided stackable>
          <Grid.Row className="">
            <Grid.Column mobile={16} tablet={8} computer={8}>
              <div className="down-modal">
                {form.type === 'ORGANISATION' ? (
                  <>
                    <AvField
                      label={t('formulary.organisation_name')}
                      className="org-inputs"
                      name="name"
                      type="text"
                      validate={{
                        required: {
                          value: true,
                          errorMessage: t(
                            'formulary.validation.organisation_name_required'
                          ),
                        },
                      }}
                    />

                    <AvField
                      label={t('formulary.organisation_sector_type')}
                      className="org-inputs"
                      name="industrySectorTypeId"
                      type="select"
                      validate={{
                        required: {
                          value: true,
                          errorMessage: t(
                            'formulary.validation.organisation_sector_type_required'
                          ),
                        },
                      }}
                    >
                      <option value="" disabled defaultValue>
                        {t('formulary.placeholder.select_sector')}
                      </option>
                      {this.selectSectorType()}
                    </AvField>

                    {isBetaLaunchAdmin && (
                      <AvField
                        label={t('formulary.currency_type')}
                        className="org-inputs"
                        name="currencyTypeId"
                        type="select"
                        validate={{
                          required: {
                            value: true,
                            errorMessage: t(
                              'formulary.validation.currency_type_required'
                            ),
                          },
                        }}
                      >
                        <option value="" disabled defaultValue>
                          {t('formulary.placeholder.select_currency_type')}
                        </option>
                        {this.currencyTypeOptions()}
                      </AvField>
                    )}

                    <AvField
                      label={t('formulary.phone')}
                      className="org-inputs"
                      name="phone"
                      type="number"
                      validate={{
                        minLength: {
                          value: 10,
                          errorMessage: t(
                            'formulary.validation.minimum_10_digits'
                          ),
                        },
                        required: {
                          value: true,
                          errorMessage: t(
                            'formulary.validation.phone_required'
                          ),
                        },
                      }}
                    />

                    <AvField
                      label={t('formulary.web_domain')}
                      className="org-inputs"
                      name="domain"
                      type="text"
                      validate={{
                        required: {
                          value: true,
                          errorMessage: t(
                            'formulary.validation.web_domain_required'
                          ),
                        },
                      }}
                    />
                    <AvField
                      label={t('formulary.email')}
                      className="org-inputs"
                      name="email"
                      type="email"
                      validate={{
                        required: {
                          value: true,
                          errorMessage: t(
                            'formulary.validation.email_required'
                          ),
                        },
                      }}
                    />
                    <div className="org-account-img-upload">
                      <AvFieldUpload
                        ref={this.fileInput}
                        label={t('formulary.organisation_logo')}
                        name="logo"
                        imageUrl={defaultValueLogo}
                        helpMessage={t('formulary.supports_formats')}
                        accept="image/gmp, image/jpg, image/jpeg, image/png"
                        buttonText={t('images.upload_image')}
                      />
                    </div>

                    <div className="account-type-toggle">
                      <Grid>
                        <Grid.Row mobile={16} tablet={16} computer={10}>
                          <div className="edit-outcome-status-bar">
                            <label>
                              {t(
                                'admin.user_organisation.accounts.activate_accounts'
                              )}
                            </label>
                            <div className="two-step-radio-container-admin radio-left">
                              <Radio
                                toggle
                                className="modal-toggle"
                                checked={isActive}
                                onChange={() => this.onChange('isDisable')}
                              />
                            </div>
                          </div>
                        </Grid.Row>
                        <Grid.Row mobile={16} tablet={16} computer={10}>
                          <div className="edit-outcome-status-bar">
                            <label>
                              {t(
                                'admin.user_organisation.accounts.block_evidence'
                              )}
                            </label>
                            <div className="two-step-radio-container-admin radio-left">
                              <Radio
                                toggle
                                className="modal-toggle-bvidence"
                                checked={isEvidenceBlock}
                                onChange={() =>
                                  this.onChange('isEvidenceBlock')
                                }
                              />
                            </div>
                          </div>
                          <div className="edit-outcome-status-bar">
                            <label>
                              {t(
                                'admin.user_organisation.accounts.demo_account'
                              )}
                            </label>
                            <div className="two-step-radio-container-admin radio-left">
                              <Radio
                                toggle
                                className="modal-toggle"
                                checked={isDemo}
                                onChange={() => this.onChange('isDemo')}
                              />
                            </div>
                          </div>
                        </Grid.Row>
                        <Grid.Row mobile={16} tablet={16} computer={10}>
                          <div className="edit-outcome-status-bar">
                            <label>{t('common.beta_tester')}</label>
                            <div className="two-step-radio-container-admin radio-left">
                              <Radio
                                toggle
                                className="modal-toggle"
                                checked={isBetaTester}
                                onChange={() => this.onChange('isBetaTester')}
                              />
                            </div>
                          </div>
                        </Grid.Row>
                        <Grid.Row mobile={16} tablet={16} computer={10}>
                          <div className="edit-outcome-status-bar">
                            <label>
                              {t(
                                'organisation.permissions.environmental_tester'
                              )}
                            </label>
                            <div className="two-step-radio-container-admin radio-left">
                              <Radio
                                toggle
                                className="modal-toggle"
                                checked={isEnvironmentalTester}
                                onChange={() =>
                                  this.onChange('isEnvironmentalTester')
                                }
                              />
                            </div>
                          </div>
                        </Grid.Row>
                        <Grid.Row mobile={16} tablet={16} computer={10}>
                          <div className="edit-outcome-status-bar">
                            <label>
                              {t('admin.user_organisation.graded_questions')}
                            </label>
                            <div className="two-step-radio-container-admin radio-left">
                              <Radio
                                toggle
                                className="modal-toggle"
                                checked={gradedQuestions}
                                onChange={() =>
                                  this.onChange('gradedQuestions')
                                }
                              />
                            </div>
                          </div>
                        </Grid.Row>
                        <Grid.Row mobile={16} tablet={16} computer={10}>
                          <div className="edit-outcome-status-bar">
                            <label>
                              {t(
                                'admin.user_organisation.graded_questions_on_by_default'
                              )}
                            </label>
                            <div className="two-step-radio-container-admin radio-left">
                              <Radio
                                toggle
                                className="modal-toggle"
                                checked={activityUsesQuestionBetaByDefault}
                                onChange={() =>
                                  this.onChange(
                                    'activityUsesQuestionBetaByDefault'
                                  )
                                }
                              />
                            </div>
                          </div>
                        </Grid.Row>
                      </Grid>
                    </div>
                  </>
                ) : (
                  //individual
                  <div className="">
                    <div className="form-group">
                      <label>{t('formulary.subscription')}</label>
                      <label className="act-inputs form-control primary-goal-container">
                        {this.renderSubscriptionsEdit()}
                      </label>
                    </div>

                    {isBetaLaunchAdmin && (
                      <AvField
                        label={t('formulary.currency_type')}
                        className="org-inputs"
                        name="currencyTypeId"
                        type="select"
                        validate={{
                          required: {
                            value: true,
                            errorMessage: t(
                              'formulary.validation.currency_type_required'
                            ),
                          },
                        }}
                      >
                        <option value="" disabled defaultValue>
                          {t('formulary.placeholder.select_currency_type')}
                        </option>
                        {this.currencyTypeOptions()}
                      </AvField>
                    )}

                    <AvField
                      label={t('formulary.first_name')}
                      className="org-inputs"
                      name="individual.firstName"
                      type="text"
                      validate={{
                        required: {
                          value: true,
                          errorMessage: t(
                            'formulary.validation.first_name_required'
                          ),
                        },
                      }}
                    />

                    <div />
                    <AvField
                      label={t('formulary.phone')}
                      className="org-inputs-individual-phone"
                      name="phone"
                      type="number"
                      validate={{
                        minLength: {
                          value: 10,
                          errorMessage: t(
                            'formulary.validation.minimum_10_digits'
                          ),
                        },
                        required: {
                          value: true,
                          errorMessage: t(
                            'formulary.validation.phone_required'
                          ),
                        },
                      }}
                    />
                    <div className="individual-account-img-upload">
                      <AvFieldUpload
                        ref={this.fileInput}
                        label={t('formulary.account_logo')}
                        name="logo"
                        imageUrl={defaultValueLogo}
                        helpMessage={t('formulary.supports_formats')}
                        accept="image/gmp, image/jpg, image/jpeg, image/png"
                        buttonText={t('images.upload_image')}
                      />
                    </div>

                    <div className="account-type-toggle-individual">
                      <Grid>
                        <Grid.Row mobile={16} tablet={16} computer={10}>
                          <div className="edit-outcome-status-bar">
                            <label>
                              {t(
                                'admin.user_organisation.accounts.activate_account'
                              )}
                            </label>
                            <div className="two-step-radio-container-admin radio-left">
                              <Radio
                                toggle
                                className="modal-toggle"
                                checked={isActive}
                                onChange={() => this.onChange('isDisable')}
                              />
                            </div>
                          </div>
                        </Grid.Row>
                        <Grid.Row mobile={16} tablet={16} computer={10}>
                          <div className="edit-outcome-status-bar">
                            <label>
                              {t(
                                'admin.user_organisation.accounts.block_evidence'
                              )}
                            </label>
                            <div className="two-step-radio-container-admin radio-left">
                              <Radio
                                toggle
                                className="modal-toggle"
                                checked={isEvidenceBlock}
                                onChange={() =>
                                  this.onChange('isEvidenceBlock')
                                }
                              />
                            </div>
                          </div>
                          <div className="edit-outcome-status-bar">
                            <label>
                              {t(
                                'admin.user_organisation.accounts.demo_account'
                              )}
                            </label>
                            <div className="two-step-radio-container-admin radio-left">
                              <Radio
                                toggle
                                className="modal-toggle-bdemo"
                                checked={isDemo}
                                onChange={() => this.onChange('isDemo')}
                              />
                            </div>
                          </div>
                          <div className="edit-outcome-status-bar">
                            <label>{t('common.beta_tester')}</label>
                            <div className="two-step-radio-container-admin radio-left">
                              <Radio
                                toggle
                                className="modal-toggle-bdemo"
                                checked={isBetaTester}
                                onChange={() => this.onChange('isBetaTester')}
                              />
                            </div>
                          </div>
                          <div className="edit-outcome-status-bar">
                            <label>
                              {t(
                                'organisation.permissions.environmental_tester'
                              )}
                            </label>
                            <div className="two-step-radio-container-admin radio-left">
                              <Radio
                                toggle
                                className="modal-toggle-bdemo"
                                checked={isEnvironmentalTester}
                                onChange={() =>
                                  this.onChange('isEnvironmentalTester')
                                }
                              />
                            </div>
                          </div>
                        </Grid.Row>
                      </Grid>
                    </div>
                  </div>
                )}
              </div>
            </Grid.Column>
            <Grid.Column
              mobile={16}
              tablet={8}
              computer={8}
              className="org-modal-column "
            >
              <div>
                {form.type === 'ORGANISATION' ? (
                  <div>
                    <AvField
                      label={t('formulary.address_line_1')}
                      className="org-inputs"
                      name="streetAddress"
                      type="text"
                      validate={{
                        required: {
                          value: true,
                          errorMessage: t(
                            'formulary.validation.address_required'
                          ),
                        },
                      }}
                    />

                    <AvField
                      label={t('formulary.address_line_2')}
                      className="org-inputs"
                      name="streetAddress2"
                      type="text"
                    />

                    <AvField
                      label={t('formulary.city_suburb')}
                      className="org-inputs"
                      name="citySuburb"
                      type="text"
                      validate={{
                        required: {
                          value: true,
                          errorMessage: t(
                            'formulary.validation.city_suburb_required'
                          ),
                        },
                      }}
                    />

                    <AvField
                      label={t('formulary.state')}
                      className="org-inputs"
                      name="stateId"
                      type="select"
                      validate={{
                        required: {
                          value: true,
                          errorMessage: t(
                            'formulary.validation.state_required'
                          ),
                        },
                      }}
                    >
                      <option value="" disabled defaultValue>
                        {t('formulary.placeholder.select_state')}
                      </option>
                      {this.renderState()}
                    </AvField>

                    <AvField
                      label={t('formulary.postcode')}
                      className="org-inputs"
                      name="postcode"
                      type="text"
                      validate={{
                        required: {
                          value: true,
                          errorMessage: t(
                            'formulary.validation.postcode_required'
                          ),
                        },
                      }}
                    />
                  </div>
                ) : (
                  <div>
                    <AvField
                      label={t('formulary.payment_preference')}
                      className="org-inputs"
                      name="paymentPreferenceId"
                      type="select"
                      validate={{
                        required: {
                          value: true,
                          errorMessage: t(
                            'formulary.validation.payment_preference_required'
                          ),
                        },
                      }}
                    >
                      <option value="" defaultValue disabled>
                        {t('formulary.placeholder.select_payment_preference')}
                      </option>
                      {this.renderPaymentPreferenceEdit()}
                    </AvField>
                    <AvField
                      label={t('formulary.surname')}
                      className="org-inputs"
                      name="individual.surname"
                      type="text"
                      validate={{
                        required: {
                          value: true,
                          errorMessage: t(
                            'formulary.validation.surname_required'
                          ),
                        },
                      }}
                      autoComplete="off"
                    />

                    <AvField
                      label={t('formulary.email')}
                      className="org-inputs"
                      name="email"
                      type="email"
                      validate={{
                        required: {
                          value: true,
                          errorMessage: t(
                            'formulary.validation.email_required'
                          ),
                        },
                      }}
                    />
                  </div>
                )}
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <div className="model-buttons-org">
          <Button
            className="Secondary-Button"
            type="button"
            onClick={() => toggle()}
          >
            {t('actions.cancel')}
          </Button>
          <Button
            content={t('actions.save')}
            type="submit"
            className="Primary-Button"
            loading={submitLoading}
            disabled={submitLoading}
          />
        </div>
      </AvForm>
    );
  }
}

class BillingInvoices extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }
  render() {
    const { modal } = this.state;
    const { data, t } = this.props;

    return (
      <div className="button-outcome">
        <Modal
          open={modal}
          onOpen={() => this.toggle()}
          onClick={(e) => stopPropagation(e)}
          onFocus={(e) => stopPropagation(e)}
          closeIcon={
            <Icon
              onClick={() => this.toggle()}
              name="close"
              className="closeicon"
            />
          }
          className="billing-and-invoices"
          size="small"
          trigger={
            <label className="edit-org">
              {t('admin.user_organisation.accounts.billing_and_invoices')}
              <Icon name="file outline" />
            </label>
          }
        >
          <Modal.Header>
            <div className="add-org-header">
              {t('admin.user_organisation.accounts.billing_and_invoices')} -{' '}
              {data.name}
            </div>
          </Modal.Header>

          <Modal.Content>
            <BillingForm {...this.props} toggle={() => this.toggle()} />
          </Modal.Content>
        </Modal>
      </div>
    );
  }
}

const IndividualDetails = ({
  isTaksoAdminEmail,
  onChange,
  isDemo,
  isBetaTester,
  isEnvironmentalTester,
  isEvidenceBlock,
}) => {
  const [isShownPass, setIsShownPass] = useState(false);
  const { t } = useTranslation();

  return (
    <div className="down-modal">
      <CustomInput
        id="userFirstNameIndv"
        name="userFirstNameIndv"
        placeholder={t('formulary.placeholder.enter_first_name')}
        className="org-inputs"
        labelText={t('formulary.first_name')}
        requiredStar
      />

      <CustomInput
        id="userPhoneIndv"
        name="userPhoneIndv"
        placeholder={t('formulary.placeholder.enter_phone')}
        className="org-inputs"
        labelText={t('formulary.phone')}
        requiredStar
      />

      {isTaksoAdminEmail && (
        <>
          <CustomPasswordInput
            id="passwordIndv"
            name="passwordIndv"
            className="org-inputs"
            labelText={t('formulary.new_password')}
            placeholder={t('formulary.placeholder.enter_new_password')}
          />

          <CustomInput
            id="confirmPasswordIndv"
            className="org-inputs"
            name="confirmPasswordIndv"
            placeholder={t('formulary.placeholder.confirm_password')}
            labelText={t('formulary.placeholder.enter_confirm_password')}
            type={isShownPass ? 'text' : 'password'}
            icon={
              <Icon
                name={isShownPass ? 'eye' : 'eye slash'}
                onClick={() => {
                  setIsShownPass(!isShownPass);
                }}
                link
              />
            }
          />
        </>
      )}

      <div className="account-type-toggle">
        <div className="edit-outcome-status-bar">
          <div className="two-step-radio-container-admin radio-left">
            <Radio
              toggle
              className="modal-toggle-qs-acctype"
              checked={isEvidenceBlock}
              onChange={() => onChange('isEvidenceBlock')}
            />
          </div>
          <label>{t('admin.user_organisation.accounts.block_evidence')}</label>
        </div>
        <div className="edit-outcome-status-bar">
          <div className="two-step-radio-container-admin radio-left">
            <Radio
              toggle
              className="modal-toggle-qs-acctype"
              checked={isDemo}
              onChange={() => onChange('isDemo')}
            />
          </div>
          <label>{t('admin.user_organisation.accounts.demo_account')}</label>
        </div>
        <div className="edit-outcome-status-bar">
          <div className="two-step-radio-container-admin radio-left">
            <Radio
              toggle
              className="modal-toggle-qs-acctype"
              checked={isBetaTester}
              onChange={() => onChange('isBetaTester')}
            />
          </div>
          <label>{t('common.beta_tester')}</label>
        </div>
        <div className="edit-outcome-status-bar">
          <div className="two-step-radio-container-admin radio-left">
            <Radio
              toggle
              className="modal-toggle-qs-acctype"
              checked={isEnvironmentalTester}
              onChange={() => onChange('isEnvironmentalTester')}
            />
          </div>
          <label>{t('organisation.permissions.environmental_tester')}</label>
        </div>
      </div>
    </div>
  );
};

class BillingForm extends PureComponent {
  constructor(props) {
    super(props);
    const { t } = this.props;
    this.state = {
      columns: [
        {
          title: <div>{t('common.date')}</div>,
          render: (data) => {
            return <div>{moment(data.createdAt).format('DD-MM-YYYY')}</div>;
          },
          textAlign: isBrowser || isTablet ? 'centre' : null,
        },
        {
          title: <div>{t('admin.user_organisation.accounts.invoice_id')}</div>,
          render: (data) => {
            if (data.invoiceUrl) {
              return (
                <a
                  className="invoice-link"
                  href={data.invoiceUrl}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <div>{data.invoiceNo}</div>
                </a>
              );
            }
            return <div>{data.invoiceNo}</div>;
          },
          textAlign: isBrowser || isTablet ? 'centre' : null,
        },
        {
          title: <div>{t('admin.user_organisation.accounts.amount')}</div>,
          render: (data) => {
            return <div>{data.amount}</div>;
          },
          textAlign: isBrowser || isTablet ? 'centre' : null,
        },
        {
          title: <div>{t('common.status')}</div>,
          render: (data) => {
            return (
              <div className={`subscription-status ${data.status}`}>
                {getInvoicesStatus(data.status)}
              </div>
            );
          },
          textAlign: isBrowser || isTablet ? 'centre' : null,
        },
        {
          title: <div>{t('admin.user_organisation.accounts.marked_by')}</div>,
          render: (data) => {
            return (
              <div className="acc-marked">
                {data.paymentPreferenceId === 2 && data.status !== 'paid' ? (
                  <MarkAcceptanceModal
                    {...this.props}
                    data={data}
                    status={this.state.status}
                  />
                ) : (
                  <>
                    <div>
                      {data.status === 'paid' && data.paymentPreferenceId === 1
                        ? t('admin.user_organisation.accounts.system')
                        : data.marked
                          ? data.marked.name
                          : '-'}
                    </div>
                    <div className="icon-comment">
                      {data.markedDescription !== null ? (
                        <Popup
                          content={
                            <div>
                              <b>{t('formulary.description')} - </b>
                              {data.markedDescription}
                              <br></br>
                              <b>{t('formulary.reference')} - </b>
                              {data.bankReferenceId}
                            </div>
                          }
                          trigger={
                            <Icon name="comment alternate" color="orange" />
                          }
                        />
                      ) : null}
                    </div>
                  </>
                )}
              </div>
            );
          },
          textAlign: isBrowser || isTablet ? 'centre' : null,
        },
        {
          title: <div>{t('admin.user_organisation.accounts.marked_on')}</div>,
          render: (data) => {
            return (
              <div>
                {data.status === 'paid' && data.paymentPreferenceId === 1
                  ? moment(data.updatedAt).format('ddd DD MMM YYYY')
                  : data.markedOn
                    ? moment(data.markedOn).format('ddd DD MMM YYYY')
                    : '-'}
              </div>
            );
          },
          textAlign: isBrowser || isTablet ? 'centre' : null,
        },
      ],
      currentPage: 1,
      status: 'all',
    };
  }

  async setStatus(statusType) {
    const { getInvoices, data } = this.props;

    await this.setState({
      status: statusType,
    });

    const { currentPage, status } = this.state;
    getInvoices(data.id, {
      currentPage,
      status,
    });
  }

  componentDidMount() {
    const { getInvoices, data } = this.props;
    const { status, currentPage } = this.state;

    getInvoices(data.id, {
      currentPage,
      status,
    });
  }

  pageChange(page) {
    const { getInvoices, user } = this.props;
    const { status } = this.state;
    this.setState(
      {
        currentPage: page,
      },
      () => {
        getInvoices(user.organisation.id, {
          page,
          status,
        });
      }
    );
  }

  render() {
    const { status, columns, currentPage } = this.state;
    const { orgInvoices, orgInvoicesLoading, t } = this.props;

    return (
      <div>
        <div className="billing-filter m-4">
          <div className="label">{t('common.status')}:</div>
          <div className="account-filter ">
            <Dropdown
              selectOnBlur={false}
              options={INVOICE_STATUS_OPTIONS(t)}
              value={status}
              onChange={(e, { value }) => this.setStatus(value)}
            />
          </div>
        </div>
        <Segment
          basic
          loading={orgInvoicesLoading}
          disabled={orgInvoicesLoading}
        >
          {orgInvoices.docs && orgInvoices.docs.length ? (
            <CustomTable
              header
              columns={columns}
              data={orgInvoices.docs}
              pagination
              customClass="super-admin-table tbody-hover"
              handlePaginationChange={(page) => this.pageChange(page)}
              page={currentPage}
              noOfPages={orgInvoices.pages}
              keyExtractor={(item, index) => item.id}
            />
          ) : (
            <EmptyContainer
              msg={t(
                'admin.user_organisation.accounts.no_invoices_for_organisation'
              )}
            />
          )}
        </Segment>
      </div>
    );
  }
}

BillingForm = withTranslation()(BillingForm);

class MarkAcceptanceModal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }

  markToggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }
  render() {
    const { modal } = this.state;
    const { t } = this.props;
    return (
      <div className="button-outcome">
        <Modal
          open={modal}
          onOpen={() => this.markToggle()}
          closeIcon={
            <Icon
              onClick={() => this.markToggle()}
              name="close"
              className="closeicon"
            />
          }
          className="contentOrganization-edit"
          size="small"
          trigger={
            <div className="markPaid">
              {t('admin.user_organisation.accounts.mark_as_paid_now')}
            </div>
          }
        >
          <Modal.Header>
            <div className="add-org-header">
              {t(
                'admin.user_organisation.accounts.mark_as_paid_now'
              ).toUpperCase()}
            </div>
          </Modal.Header>

          <Modal.Content>
            <AcceptanceForm
              markToggle={() => this.markToggle()}
              {...this.props}
            />
          </Modal.Content>
        </Modal>
      </div>
    );
  }
}

class AcceptanceForm extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {};
  }

  async handleValidSubmit(event, values) {
    try {
      const { updateMarkBy, data, markToggle, status } = this.props;

      await updateMarkBy(data.id, data.organisationId, values, status);
      markToggle();
    } catch (error) {
      console.error('Mark by ~~', error);
    }
  }

  render() {
    const { toggle, t } = this.props;
    const { markByLoading } = this.props.admin;

    return (
      <div>
        <AvForm
          onValidSubmit={(event, values) =>
            this.handleValidSubmit(event, values)
          }
        >
          <div className="mark-paid-modal">
            <AvField
              label={t('admin.user_organisation.accounts.date')}
              className="org-inputs"
              name="markedOn"
              type="date"
              validate={{
                required: {
                  value: true,
                  errorMessage: t(
                    'admin.user_organisation.accounts.date_required'
                  ),
                },
              }}
            />

            <AvField
              label={t('admin.user_organisation.accounts.bank_reference_id')}
              className="org-inputs"
              name="bankReferenceId"
              type="text"
              validate={{
                required: {
                  value: true,
                  errorMessage: t(
                    'admin.user_organisation.accounts.bank_reference_id_required'
                  ),
                },
              }}
            />

            <AvField
              label={t('admin.user_organisation.accounts.comments')}
              className="org-inputs-textarea"
              name="markedDescription"
              type="textarea"
              validate={{
                required: {
                  value: true,
                  errorMessage: t(
                    'admin.user_organisation.accounts.comments_required'
                  ),
                },
              }}
            />
          </div>
          <div className="model-buttons-account">
            <Button
              className="goal-cancel-button"
              type="button"
              onClick={() => toggle()}
            >
              {t('actions.cancel')}
            </Button>
            <Button
              content={t('actions.save')}
              type="submit"
              className="goal-create-button"
              loading={markByLoading}
              disabled={markByLoading}
            />
          </div>
        </AvForm>
      </div>
    );
  }
}

AcceptanceForm = withTranslation()(AcceptanceForm);

const IndividualRightSide = ({ isTaksoAdminEmail, setIsTaksoAdminEmail }) => {
  const { t } = useTranslation();
  return (
    <div className="down-modal-individual-right-side">
      <CustomInput
        id="userSurnameIndv"
        name="userSurnameIndv"
        placeholder={t('formulary.placeholder.enter_surname')}
        className="org-inputs"
        labelText={t('formulary.surname')}
        requiredStar
      />

      <CustomCheckbox
        className="check-box"
        id="isTaksoAdminEmail"
        name="isTaksoAdminEmail"
        label={t('admin.user_organisation.accounts.takso_support_email')}
        checked={isTaksoAdminEmail}
        onChange={() => setIsTaksoAdminEmail()}
      />

      <CustomInput
        id="userEmailIndv"
        name="userEmailIndv"
        placeholder={t('formulary.placeholder.enter_email')}
        labelText={t('formulary.email')}
        className="org-inputs"
        requiredStar
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    industrySectorTypes: state.extra.industrySectorTypes,
    admin: state.admin,
    provincesAndStates: state.extra.provincesAndStates,
    organization: state.organization,
    auth: state.authentication,
    orgInvoices: state.organization.orgInvoices,
    orgInvoicesLoading: state.organization.orgInvoicesLoading,
    subscriptions: state.extra.subscriptions,
    paymentPreferences: state.extra.paymentPreferences,
    individualUser: state.admin.individualUser,
    getPermissionGroup: state.admin.getPermissionGroup,
    getPermissionLoading: state.admin.getPermissionLoading,
    features: state.admin.features,
    getfeatureLoading: state.admin.getfeatureLoading,
    currencyTypes: state.extra.currencyTypes,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getIndustrySectorTypes,
      getOrgAll,
      postOrganisation,
      getProvincesAndStates,
      updateOrganizationLogo,
      updateOrganisationDetails,
      getInvoices,
      updateMarkBy,
      getSubscriptions,
      getPaymentPreferences,
      getFeatures,
      getPermissionGroups,
      postAccountPermissionGroups,
      getCurrencyTypes,
    },
    dispatch
  );
};

let Organizations = withTranslation()(OrganizationsBase);
Organizations = connect(mapStateToProps, mapDispatchToProps)(Organizations);

export { Organizations };
